module.exports = __webpack_public_path__ + "img/house_pv_error_online.48d555fb.png";